/* eslint-disable */
import { TransactionResponse } from '@ethersproject/providers'
import { Token } from '@noahswap/sdk'
import { Box, Flex, Text, useMatchBreakpoints, Button, useModal } from '@noahswap/uikit'
import { useWeb3React } from '@noahswap/wagmi'
import { useTokenBalance } from 'state/wallet/hooks'
import styled from 'styled-components'
import { useRouterContract } from 'utils/exchange'
import { getBalanceAmount, formatBigNumberToFixed } from 'utils/formatBalance'
import Page from 'views/Page'
import { useAirdropContract } from 'hooks/useContract'
import ConnectWalletButton from 'components/ConnectWalletButton'
import { useActiveChainId } from 'hooks/useActiveChainId'
import { useEffect, useState, useRef } from 'react'
import { getTokenHoldersSnapshotRank } from 'service/service'
import chainUtils from 'service/chainUtils'
import { useRouter } from 'next/router'
import { useTranslation } from '@noahswap/localization'
import { calculateGasMargin } from 'utils'
import { useGasPrice } from 'state/user/hooks'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
// eslint-disable-next-line import/no-named-as-default
import ResultModal from './components/ResultModal'
// import Progress from './components/Progress'
import BigNumber from 'bignumber.js'
import Link from 'next/link'
import React from 'react'

const Titles = styled.div<{ isMobile?: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '100%' : '1000px')};
  // width: 100%;
  margin-bottom: 20px;
  font-size: ${({ isMobile }) => (isMobile ? '20px' : '30px')};
  line-height: ${({ isMobile }) => (isMobile ? '24px' : '35px')};
  font-weight: 600;
  // position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img {
    width: ${({ isMobile }) => (isMobile ? '150px' : '140px')};
    height: auto;
    // position: relative;
  }
`

const AdLeftImg = styled.img`
  width: 100px;
  height: auto;
  position: absolute;
  top: 10%;
  left: -20%;
`

const AdRightImg = styled.img`
  width: 100px;
  height: auto;
  position: absolute;
  top: 40%;
  right: -20%;
`

const Pointer = styled.span`
  width: auto;
  height: 35px;
  padding: 5px 20px;
  font-size: 14px;
  border-radius: 20px 5px 5px 0;
  background-color: #fde16f;
  border: 1px solid #14162a;
  box-shadow: 3px 3px 1px #000;
  font-weight: bold;
  display: flex;
  align-items: center;
  white-space: nowrap;
`

const BigTit = styled.span<{ isMobile?: boolean }>`
  font-size: ${({ isMobile }) => (isMobile ? '16px' : '26px')};
  line-height: ${({ isMobile }) => (isMobile ? '20px' : '30px')};
  font-weight: bold;
  margin-left: ${({ isMobile }) => (isMobile ? '0px' : '20px')};
  margin-top: ${({ isMobile }) => (isMobile ? '20px' : '0px')};
`
const SmallTit = styled.span<{ isMobile?: boolean }>`
  font-size: ${({ isMobile }) => (isMobile ? '16px' : '22px')};
  // line-height: ${({ isMobile }) => (isMobile ? '12px' : '14px')};
  height: 22px;
  font-weight: bold;
  display: inline-block;
  position: relative;
  z-index: 4;
  // border-bottom: ${({ isMobile }) => (isMobile ? '5px solid #fde16f;' : '10px solid #fde16f;')};
  &:after {
    content: '';
    position: absolute;
    bottom: ${({ isMobile }) => (isMobile ? '-6px' : '-6px')};
    height: 22px;
    left: 0;
    width: 100%;
    z-index: -1;
    height: 10px;
    background: #fde16f;
  }
`
const FlexJu = styled.div<{ isMobile?: boolean }>`
  display: flex;
  align-items: ${({ isMobile }) => (isMobile ? 'flex-start' : 'center')};
  margin-bottom: 40px;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
`
const Boxs = styled.div`
  margin-bottom: 40px;
  & > li {
    line-height: 20px;
  }
`

const More = styled.div`
  background: #fde16f;
  border-radius: 4px;
  font-size: 12px;
  padding: 8px 10px;
  cursor: pointer;
`
const BulletList = styled.ul<{ isMobile?: boolean }>`
  list-style-type: none;
  margin: 20px 0;
  padding: 0;
  li {
    margin: 0;
    padding: 0;
    line-height: ${({ isMobile }) => (isMobile ? '18px' : '20px')};
    font-size: ${({ isMobile }) => (isMobile ? '14px' : '16px')};
  }
  li::before {
    content: '•';
    margin-right: 4px;
  }
  li::marker {
    font-size: 12px;
  }
  div {
    white-space: pre-line;
    font-size: ${({ isMobile }) => (isMobile ? '14px' : '16px')};
    line-height: ${({ isMobile }) => (isMobile ? '18px' : '20px')};
  }
`

const Tables = styled.div`
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #14162a;
`
const Headers = styled.div<{ isMobile?: boolean }>`
  font-size: ${({ isMobile }) => (isMobile ? '13px' : '16px')};
  color: #fde16f;
  font-weight: bold;
  display: flex;
  background: #14162a;
  border-radius: 8px 8px 0px 0px;
`

const HeadersText = styled.div`
  flex: 1;
  padding: 10px 0;
  minheight: 50px;
  display: flex;
  align-items: center;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #8c8c8c;
  &:last-child {
    border-right: none;
  }
`

const Bodys = styled.div`
  font-size: 14px;
  display: flex;
  border-bottom: 1px solid #8c8c8c;
  &:last-child {
    border-bottom: none;
  }
`
const BodysText = styled.div<{ isMobile?: boolean }>`
  font-size: ${({ isMobile }) => (isMobile ? '12px' : '14px')};
  border-right: 1px solid #8c8c8c;
  flex: 1;
  minheight: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 15px 0;
  &:last-child {
    border-right: none;
  }
`

const Wrap = styled.div<{ isMobile?: boolean }>`
  width: ${({ isMobile }) => (isMobile ? '100%' : '1000px')};
  margin-bottom: 20px;
  position: relative;
  z-index: 10000;
`

// const WrapBox = styled.div<{ isMobile?: boolean }>`
//   background-color: #fff;
//   border-radius: 16px;
//   padding: ${({ isMobile }) => (isMobile ? '20px' : '40px')};
//   /* width: 800px; */
//   margin-bottom: 20px;
//   width: 100%;
// `

const MainWrap = styled.div<{ isMobile?: boolean }>`
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
  padding: ${({ isMobile }) => (isMobile ? '20px' : '40px')};
  margin-bottom: 20px;
  width: 100%;
  position: relative;
`

export default function AirDrop() {
  const {
    t,
    currentLanguage: { code: langCode },
  } = useTranslation()
  const router = useRouter()
  // const parsedQueryChainId = Number(router.query.chainId)
  // const chainId = parsedQueryChainId
  // const { chainId } = useActiveWeb3React()
  const { account } = useWeb3React()
  const { isMobile } = useMatchBreakpoints()
  const [myRank, setMyRank] = useState<any>(0)
  useEffect(() => {
    // if (!chainId) return
    const { baseURL, chainid } = chainUtils()
    const params = {
      pairId: '0x2dfada2212e534b7e234fb877dca4ddcaef049b7',
    }
    // if (account) {
    const fetch = async () => {
      const { data, code } = await getTokenHoldersSnapshotRank(params, { baseURL, chainid, account })
      if (!code) {
        // setAirList(data)
        setMyRank(data.rank)
      }
    }
    fetch()
    // }
  }, [account])
  // 0x6a46efcb54feb6a920f607943e1c35425095ec0e5ac49246ed66fd8d0861fa67 hash
  // const handleClaim = async () => {
  //   setAirdropState({ attemptingTxn: true, airdropErrorMessage: undefined, txHash: undefined })
  //   // const estimate = airdropContract.estimateGas.claim
  //   const method = airdropContract.claim

  //   console.log(chainId, 'chainId')
  //   console.log(210000, 'gasLimit')
  //   console.log(gasPrice, 'gasPrice')
  //   await method({
  //     // gasLimit: calculateGasMargin(estimatedGasLimit),
  //     gasLimit: 210000,
  //     gasPrice,
  //   })
  //     .then((response) => {
  //       setAirdropState({ attemptingTxn: false, airdropErrorMessage: undefined, txHash: response.hash })
  //       setTimeout(() => {
  //         getData(account)
  //       }, 5000)
  //     })
  //     .catch((err) => {
  //       if (err && err.code !== 4001) {
  //         setAirdropState({
  //           attemptingTxn: false,
  //           airdropErrorMessage: err.message,
  //           txHash: undefined,
  //         })
  //       }
  //     })
  // }

  //   await estimate()
  //     .then((estimatedGasLimit) => {
  //       console.log(calculateGasMargin(estimatedGasLimit), 'calculateGasMargin(estimatedGasLimit)')
  //       method({
  // gasLimit: calculateGasMargin(estimatedGasLimit),
  //         gasPrice,
  //       }).then((response) => {
  //         setAirdropState({ attemptingTxn: false, airdropErrorMessage: undefined, txHash: response.hash })
  //         setTimeout(() => {
  //           getData(account)
  //         }, 5000)
  //       })
  //       console.log(calculateGasMargin(estimatedGasLimit), 'calculateGasMargin(estimatedGasLimit)')
  //       console.log(gasPrice, 'gasPrice')
  //     }).catch((err) => {
  //       // console.log(calculateGasMargin(estimatedGasLimit), 'calculateGasMargin(estimatedGasLimit)')
  //       console.log(gasPrice, 'gasPrice')
  //       console.log(err, 'err')
  //       if (err && err.code !== 4001) {
  //         setAirdropState({
  //           attemptingTxn: false,
  //           airdropErrorMessage: err.message,
  //           txHash: undefined,
  //         })
  //       }
  //     })
  // }
  // 领取xxxNOAH
  // const pendingText = `${t('noah237')}${claimableAmounts} NOAH`

  // const [onPresentResultModal] = useModal(
  //   <ResultModal
  //     attemptingTxn={attemptingTxn}
  //     hash={txHash}
  //     airdropErrorMessage={airdropErrorMessage}
  //     claimableAmounts={claimableAmounts}
  //     pendingText={pendingText}
  //   />,
  //   false,
  //   true,
  //   'airdropModal',
  // )

  // let jumpHref = 'https://noah-finance.gitbook.io/noah/noah-airdrop-rules-2023-05-15'
  // if (langCode === 'zh-tw') {
  //   jumpHref = 'https://noah-finance.gitbook.io/noah/v/fan-ti/noah-kong-tou-gui-ze-20230515'
  // } else if (langCode === 'ko') {
  //   jumpHref = 'https://noah-finance.gitbook.io/noah/v/undefined/2023-05-15'
  // }

  return (
    <Page backImg isMobile={isMobile}>
      {/* NOAH空投 */}
      {/* <Text fontSize={isMobile ? '20px' : '30px'} fontWeight="600" mb={isMobile ? '20px' : '30px'}>
        {t('noah486')}
      </Text> */}

      <Titles isMobile={isMobile}>
        {t('noah486')}
        <img src="/images/activity/bg.png" alt="" />
      </Titles>
      <Wrap isMobile={isMobile}>
        <MainWrap isMobile={isMobile}>
          <FlexJu isMobile={isMobile}>
            <Pointer>{t('noah488')}</Pointer>
            <BigTit isMobile={isMobile}>{t('noah489')}</BigTit>
          </FlexJu>
          <Boxs>
            <SmallTit isMobile={isMobile}>{t('noah490')}</SmallTit>
            {/* <Lis>{t('noah491')}</Lis> */}
            <BulletList isMobile={isMobile}>
              <li>{t('noah491')}</li>
            </BulletList>
            <p
              style={{ color: '#DD8A00', fontSize: '13px', lineHeight: '18px', cursor: 'pointer' }}
              onClick={() =>
                window.open('https://explorer.evm.eosnetwork.com/address/0x33B57dC70014FD7AA6e1ed3080eeD2B619632B8e')
              }
            >
              {t('noah487')}
            </p>
          </Boxs>

          <Boxs>
            <SmallTit isMobile={isMobile}>{t('noah492')}</SmallTit>
            {/* <Lis>{t('noah491')}</Lis> */}
            <BulletList isMobile={isMobile}>
              <li>{t('noah493')}</li>
            </BulletList>
          </Boxs>

          <Boxs>
            <SmallTit isMobile={isMobile}>{t('noah494')}</SmallTit>
            {/* <Lis>{t('noah491')}</Lis> */}
            <BulletList isMobile={isMobile}>
              <li>{t('noah495')}</li>
            </BulletList>
            <Tables>
              <Headers isMobile={isMobile}>
                <HeadersText>{t('noah514')}</HeadersText>
                <HeadersText>{t('noah496')}</HeadersText>
                <HeadersText>{t('noah497')}</HeadersText>
              </Headers>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('noah498')}</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  3000 NOAH
                </BodysText>
                <BodysText isMobile={isMobile}>/</BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('noah499')}</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  6000 NOAH
                </BodysText>
                <BodysText isMobile={isMobile}>{t('> 600,000 USDT')}</BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('noah500')}</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  10000 NOAH
                </BodysText>
                <BodysText isMobile={isMobile}>{t('>1,000,000 USDT')}</BodysText>
              </Bodys>
            </Tables>
          </Boxs>

          <Boxs>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <SmallTit isMobile={isMobile} style={{ height: '22px' }}>
                {t('noah501')}
              </SmallTit>
              {!isMobile && (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {account && (
                    <div style={{ marginRight: '20px', fontSize: '14px' }}>
                      {t('noah530')}: {myRank}
                    </div>
                  )}
                  <More>
                    {/* {t('查看更多>')} */}
                    <Link href="/airdrop/more">{t('noah535')}</Link>
                  </More>
                </div>
              )}
            </div>
            {isMobile && (
              <div style={{ marginTop: '20px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                {account && (
                  <div style={{ marginRight: '20px', fontSize: '14px' }}>
                    {t('noah530')}: {myRank}
                  </div>
                )}
                <More>
                  {/* {t('查看更多>')} */}
                  <Link href="/airdrop/more">{t('noah535')}</Link>
                </More>
              </div>
            )}
            <BulletList isMobile={isMobile}>
              <li>{t('noah502')}</li>
            </BulletList>
            <Tables>
              <Headers isMobile={isMobile}>
                <HeadersText>{t('noah503')}</HeadersText>
                <HeadersText>{t('noah504')}</HeadersText>
                <HeadersText>{t('noah505')}</HeadersText>
              </Headers>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('1')}</BodysText>
                <BodysText isMobile={isMobile}>20%</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  2000
                </BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('2')}</BodysText>
                <BodysText isMobile={isMobile}>15%</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  1500
                </BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('3')}</BodysText>
                <BodysText isMobile={isMobile}>13%</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  1300
                </BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('4')}</BodysText>
                <BodysText isMobile={isMobile}>12%</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  1200
                </BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('5')}</BodysText>
                <BodysText isMobile={isMobile}>10%</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  1000
                </BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('6-10')}</BodysText>
                <BodysText isMobile={isMobile}>30%</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  600
                </BodysText>
              </Bodys>
            </Tables>
          </Boxs>

          <Boxs>
            <SmallTit isMobile={isMobile}>{t('noah506')}</SmallTit>
            <BulletList isMobile={isMobile}>
              <div>{t('noah507')}</div>
            </BulletList>
          </Boxs>
          {!isMobile && <AdLeftImg src="/images/activity/left.png" alt="" />}
          {!isMobile && <AdRightImg src="/images/activity/right.png" alt="" />}
        </MainWrap>
      </Wrap>

      <Wrap isMobile={isMobile} style={{ marginBottom: '200px' }}>
        <MainWrap isMobile={isMobile}>
          <FlexJu isMobile={isMobile}>
            <Pointer>{t('noah508')}</Pointer>
            <BigTit isMobile={isMobile}>{t('noah509')}</BigTit>
          </FlexJu>
          <Boxs>
            <SmallTit isMobile={isMobile}>{t('noah510')}</SmallTit>
            {/* <Lis>{t('noah491')}</Lis> */}
            <BulletList isMobile={isMobile}>
              <li>{t('noah511')}</li>
            </BulletList>
            {/* <p style={{color: '#DD8A00', fontSize: '13px'}}>{t('noah487')}</p> */}
          </Boxs>

          <Boxs>
            <SmallTit isMobile={isMobile}>{t('noah492')}</SmallTit>
            {/* <Lis>{t('noah491')}</Lis> */}
            <BulletList isMobile={isMobile}>
              <li>{t('noah512')}</li>
            </BulletList>
          </Boxs>

          <Boxs>
            <SmallTit isMobile={isMobile}>{t('noah513')}</SmallTit>
            {/* <Lis>{t('noah491')}</Lis> */}
            {/* <BulletList isMobile={isMobile}>
            <li>{t('noah495')}</li>
          </BulletList> */}
            <Tables style={{ marginTop: '20px' }}>
              <Headers isMobile={isMobile}>
                <HeadersText>{t('noah514')}</HeadersText>
                <HeadersText>
                  {t('noah517')}
                  {t('noah529')}
                </HeadersText>
                <HeadersText>{t('noah523')}</HeadersText>
              </Headers>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('noah515')}</BodysText>
                <BodysText isMobile={isMobile}>{t('noah518')}</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  3
                </BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('noah516')}</BodysText>
                <BodysText isMobile={isMobile}>{t('noah519')}</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  5
                </BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('noah516')}</BodysText>
                <BodysText isMobile={isMobile}>{t('noah520')}</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  15
                </BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('noah527')}</BodysText>
                <BodysText isMobile={isMobile}>{t('noah521')}</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  5
                </BodysText>
              </Bodys>
              <Bodys>
                <BodysText isMobile={isMobile}>{t('noah528')}</BodysText>
                <BodysText isMobile={isMobile}>{t('noah522')}</BodysText>
                <BodysText isMobile={isMobile} style={{ color: '#EE990B', fontWeight: 'bold' }}>
                  10
                </BodysText>
              </Bodys>
            </Tables>
          </Boxs>

          <Boxs>
            <SmallTit isMobile={isMobile}>{t('noah524')}</SmallTit>
            <BulletList isMobile={isMobile}>
              <div>{t('noah526')}</div>
            </BulletList>
          </Boxs>
        </MainWrap>
      </Wrap>
      {/* {account ? (

        ) : (
          
        )} */}
    </Page>
  )
}
